import { useMutation, useQueryClient } from "react-query";
import { deleteSeason } from "@/api/Customer/customer-form-api";

const customerFormKey = "customer-form";

export function useSeasonDelete({ customer_id } = {}) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params) => deleteSeason(params),
		onSuccess: () => {
			queryClient.invalidateQueries("dashboard_filters");
			if (customer_id) {
				queryClient.invalidateQueries([customerFormKey, { customer_id }]);
			}
		},
	});
}
